// Slider config moved to: assets/js/components/ui-components/slick-slider.js (preset "post-smarter")
// Template updated: templates/public/static/social-media-management/main.html.twig (data-lazy-init="slick-slider")

const { AdsServicesMarquee } = require("../../components/ads-services-marquee");

document.addEventListener("DOMContentLoaded", () => {
  const adsServicesMarquee = new AdsServicesMarquee();
  adsServicesMarquee.initMarquee();
});